module.exports = __webpack_public_path__ + "images/emoji/inbox_tray.9758c26b2ea982bd9444.png";